import {
    createFailure,
    validationFailed,
    ValidationFailure,
    ValidationResult,
    validationSuccessful
} from "sprint-common-web";

import { hasFileExtension } from "../utils/hasFileExtension";

export const validateDeliveryFolder = (deliveryFolder: string): ValidationResult => {
    const failures: ValidationFailure[] = [];

    if (!deliveryFolder.startsWith("/")) {
        const failure = createFailure("Delivery folder should start with '/'", "deliveryFolder.ContainsDirectoryChar");

        failures.push(failure);
    }

    if (hasFileExtension(deliveryFolder)) {
        const failure = createFailure(
            "Delivery folder shouldn't contain file name with extension",
            "deliveryFolder.ContainsFileExtension"
        );

        failures.push(failure);
    }

    if (failures.length) {
        return validationFailed(failures);
    }

    return validationSuccessful();
};
